module.exports = __webpack_public_path__ + "img/zw.bc89391.svg";